import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';

export const EmailSignupForm = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast({
        title: "Email required",
        description: "Please enter your email address",
        variant: "destructive"
      });
      return;
    }

    setIsLoading(true);

    try {
      // Store email in database
      const { error: dbError } = await supabase
        .from('email_signups')
        .insert([{ email }]);

      if (dbError) {
        if (dbError.code === '23505') { // Unique constraint error
          toast({
            title: "Already subscribed!",
            description: "This email is already on our list. We'll keep you updated!",
          });
        } else {
          throw dbError;
        }
      } else {
        // Send notification to founders
        await supabase.functions.invoke('notify-founders', {
          body: { email }
        });

        toast({
          title: "Success!",
          description: "Thanks for signing up! We'll keep you updated on our progress.",
        });
      }

      setEmail('');
    } catch (error) {
      console.error('Error:', error);
      toast({
        title: "Something went wrong",
        description: "Please try again later.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
      <Input
        type="email"
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="bg-white/10 border-white/20 text-white placeholder:text-white/60 focus:bg-white/20"
        disabled={isLoading}
      />
      <Button 
        type="submit"
        disabled={isLoading}
        className="bg-brand-sky-blue hover:bg-brand-sky-blue/90 text-white font-semibold whitespace-nowrap"
      >
        {isLoading ? 'Signing up...' : 'Keep Me Updated'}
      </Button>
    </form>
  );
};